<script>
import CustomTooltip from '@/components/booking/bookingList/custom-tooltip.vue'

export default {
  name: 'ExportOption',
  components: { CustomTooltip },
  props: {
    selectedCount: { type: Number, default: 0 },
  },
  emits: ['toggle'],
  data() {
    return {
      showExports: false,
    }
  },
  computed: {
    /**
     * Returns a display-friendly count, capped at 1000+.
     * @returns {string}
     */
    displayCount() {
      const cap = 1000
      if (this.selectedCount > cap) {
        return `${cap}+`
      }
      return String(this.selectedCount)
    },
  },
  mounted() {
    document.addEventListener(
      'click',
      this.handleClickOutsideExportOption,
      true
    )
  },
  beforeUnmount() {
    document.removeEventListener(
      'click',
      this.handleClickOutsideExportOption,
      true
    )
  },
  methods: {
    handleClickOutsideExportOption(e) {
      const refsToCheck = ['exportsContainer']

      const path =
        typeof e.composedPath === 'function'
          ? e.composedPath()
          : (function fallbackPath(n) {
              const p = []
              while (n) {
                p.push(n)
                n = n.parentNode || n.host
              }
              p.push(window)
              return p
            })(e.target)

      const clickedInsideRef = refsToCheck.some((ref) => {
        const el = this.$refs[ref]
        return el && path.includes(el)
      })

      const clickedOnTrigger = path.some((node) => {
        if (!(node instanceof HTMLElement)) return false
        return node.closest('.export-trigger')
      })

      const inOverlay = path.some(
        (node) =>
          node instanceof HTMLElement &&
          (node.closest('.v-menu__content') ||
            node.closest('.v-overlay__content'))
      )

      if (!clickedInsideRef && !clickedOnTrigger && !inOverlay) {
        this.showFilter = false
        this.showDateFilter = false
        this.selectedFilter = 0
        this.showExports = false
      }
    },
    toggleExportOption() {
      if (this.selectedCount > 0) {
        this.showExports = !this.showExports
      }
      this.$emit('toggle')
    },
    handleIconClick() {
      if (this.selectedCount === 0) {
        this.$emit('export')
        this.showExports = false
      } else {
        this.toggleExportOption()
      }
    },
    exportSelected() {
      this.$emit('export-selected')
      this.showExports = false
    },
    exportAll() {
      this.$emit('export')
      this.showExports = false
    },
  },
}
</script>

<template>
  <div style="position: relative">
    <CustomTooltip
      position="bottom"
      :text="$t('exportBookings.buttons.export')"
      class="export-trigger"
    >
      <v-icon
        data-export-button="export"
        class="search-icon"
        :class="showExports ? 'active' : ''"
        @click.stop="handleIconClick"
      >
        mdi-tray-arrow-down
      </v-icon>
    </CustomTooltip>

    <div v-if="showExports" ref="exportsContainer" class="export-container">
      <div
        v-if="selectedCount > 0"
        data-export-button="export-selected"
        class="mb-3 cursor-pointer export-options"
        @click.stop="exportSelected"
      >
        {{
          $tc('topFilterBar.export.selected', displayCount, {
            count: displayCount,
          })
        }}
      </div>
      <div class="cursor-pointer export-options" @click.stop="exportAll">
        {{ $t('topFilterBar.export.exportAll') }}
      </div>
    </div>
  </div>
</template>
